module.exports = {"632624100":"吉迈镇","632624200":"满掌乡","632624201":"德昂乡","632624202":"窝赛乡","632624203":"莫坝乡","632624204":"上红科乡","632624205":"下红科乡","632624206":"建设乡","632624207":"桑日麻乡","632624208":"特合土乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/632624.json
// module id = 3149
// module chunks = 0